import styled from 'styled-components';
import media from 'components/mixins/media';
import { mainFont } from 'components/mixins/typography';
import { Button } from '../../common';
import buttonDefaultStyle from '../../mixins/normalize';
import { transparentize } from '../../../utils/color';

export const Content = styled.div.attrs({
  'data-test': 'start-popover'
})`
  ${mainFont};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Figure = styled.div`
  margin: 0 auto;
`;

export const Description = styled.p`
  max-width: 652px;
  font-size: 32px;
  line-height: 1.4;
  text-align: center;
  color: ${props => props.theme.colors.textColor};
  margin: 85px auto 40px;
  ${media.mobile`
    font-size: 30px;
    max-width: 260px;
    margin-top: 52px;
  `};
`;

export const ButtonElement = styled(Button)`
  ${buttonDefaultStyle};
  flex: 0 0 auto;
  width: 140px;
  background-color: ${props => props.theme.colors.mainColor};
  &:hover,
  &:focus {
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
  }
  > span {
    font-size: 14px;
    line-height: 1;
  }
`;
